import React from 'react';
import { Sparkles, Check } from 'lucide-react';
import { ROLE_OPTIONS } from './wizardConfig';

/**
 * First onboarding step: welcome message + role selection cards.
 */
const WelcomeStep = ({ selectedRole, onSelectRole }) => (
  <div className="step-content welcome-step">
    <div className="welcome-icon">
      <Sparkles size={48} />
    </div>
    <h2>Welcome to taskeri<sup style={{ fontSize: '0.55em' }}>®</sup>! 👋</h2>
    <p className="welcome-subtitle">
      How would you like to use taskeri<sup style={{ fontSize: '0.55em' }}>®</sup>?
    </p>

    <div className="role-selection">
      {ROLE_OPTIONS.map((role) => (
        <button
          key={role.id}
          className={`role-option ${selectedRole === role.id ? 'selected' : ''}`}
          onClick={() => onSelectRole(role.id)}
          data-testid={`onboarding-role-${role.id}`}
        >
          <div className="role-header">
            <span className="role-icon">{role.icon}</span>
            <div className="role-info">
              <h3>{role.title}</h3>
              <p>{role.subtitle}</p>
            </div>
            {selectedRole === role.id && (
              <div className="role-check">
                <Check size={18} />
              </div>
            )}
          </div>
          <ul className="role-features">
            {role.features.map((feature) => (
              <li key={feature}>
                <Check size={14} />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </button>
      ))}
    </div>

    <p className="role-hint">
      You can change this anytime from your profile settings
    </p>
  </div>
);

export default WelcomeStep;
